#options {
  color: var(--text-color);
  display: grid;
  justify-items: center;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: end;
  justify-content: center;
  justify-items: center;
  row-gap: 1.5em;
}

.optElem {
  grid-column-start: 2;
}

.actionBtn {
  width: 9em;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  cursor: pointer;
  text-decoration: none;
  color: var(--background-color);
  font-size: 2em;
  background-color: var(--accent-color);
  padding: 0.3em 0;
  border: none;
  border-radius: 3em;
}

.arrowBack {
  justify-self: end;
  grid-column-start: 1;
}

.arrowForward {
  justify-self: start;
  grid-column-start: 3;
}

.modularBtn {
  cursor: pointer;
  width: 4em;
  height: 4em;
  background-color: var(--accent-color);
  border-radius: 50%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.optLabel {
  color: var(--text-color);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.inputField {
  opacity: 1;
  color: var(--text-color);
  -webkit-text-fill-color: var(--text-color);
  border-radius: 3em;
  background-color: var(--background-color);
  padding: 1.3em 2em;
  width: 20em;
  margin-top: 0.3em;
  border: 2px solid var(--text-color);
}
